export default __webpack_public_path__ + "static/media/live-icon-active.824d2d05.webp";